import { Component, OnInit } from '@angular/core';
import { HttpReportsService } from "../../service/http-reports.service";
import { ResultListDto, AbstractDto, ReportResponseDto } from '../../service/dto';

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  standalone: false,
  styleUrls: ['./reports.component.scss']
})

export class ReportsComponent implements OnInit {
  data?: ResultListDto<ReportResponseDto>;
  loading = false;
  error?: string;
  // always set (non-null) — default to today's month
  month: Date = new Date();
  startDate: Date = new Date(this.month.getFullYear(), this.month.getMonth(), 1);
  endDate: Date = new Date(this.month.getFullYear(), this.month.getMonth() + 1, 0);

  readonly columns = [
    { title: 'Partner', property: 'partnerName' },
    { title: 'Registration Count', property: 'registrationCount' },
	{ title: 'Positively Verified', property: 'positivelyVerified' },
	{ title: 'Negatively Verified', property: 'negativelyVerified' },
	{ title: 'Invalid Registrations', property: 'invalidRegistrations' },
	{ title: 'Outdated Registrations', property: 'outdatedRegistrations' },
	{ title: 'Unique Subscribers', property: 'uniqueSubscribers' },
  ];

  constructor(private httpReports: HttpReportsService) { }

  ngOnInit(): void {
    // initialize start/end dates for the default month (today)
    this.setMonthDates(this.month);
    this.load();
  }

  load(): void {
    this.loading = true;
    // startDate and endDate are always set (non-null)
    this.httpReports.getAllReports(this.startDate, this.endDate).subscribe({
      next: resp => {
        this.data = resp;
        this.loading = false;
      },
      error: e => {
        this.error = e?.message ?? 'Failed to load reports';
        this.loading = false;
      }
    });
  }

  // no-op handlers to satisfy app-table outputs
  onRowClick(_: any) { }
  onUpdateRequired(_: any) { }

  onMonthSelected(result: Date) {
    // update month, startDate and endDate when user selects a month
    this.setMonthDates(result);
    console.log('onChange: ', result, 'startDate=', this.startDate, 'endDate=', this.endDate);
  }

  // disable future dates/months in the date picker
  // for month mode we compare year/month to today's year/month
  disabledDate = (current?: Date): boolean => {
    if (!current) return false;
    const today = new Date();
    if (current.getFullYear() > today.getFullYear()) return true;
    if (current.getFullYear() === today.getFullYear() && current.getMonth() > today.getMonth()) return true;
    return false;
  }

  private setMonthDates(date?: Date | null): void {
    // Use provided date if valid, otherwise default to today
    const d = (date instanceof Date && !isNaN(date.getTime())) ? date : new Date();

    this.month = d;
    // first day of month at local time
    this.startDate = new Date(d.getFullYear(), d.getMonth(), 1);
    // last day of month: day 0 of next month
    this.endDate = new Date(d.getFullYear(), d.getMonth() + 1, 0);
	console.log('setMonthDates: ', date, ' => startDate=', this.startDate, 'endDate=', this.endDate);
	this.load();
  }
}
